import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['row', 'sectionHeader', 'modal', 'modalContent'];

  filter () {
    const onlineFilter = this.element.querySelector('[data-filter="online"]').value
    const typeFilter = this.element.querySelector('[data-filter="type"]').value
    const errorsFilter = this.element.querySelector('[data-filter="errors"]').value

    const visibleSections = new Set()

    this.rowTargets.forEach((row) => {
      const matchesOnline = onlineFilter === 'all' || row.dataset.online === onlineFilter
      const matchesType = typeFilter === 'all' || row.dataset.locationType === typeFilter
      const matchesErrors = errorsFilter === 'all' || row.dataset.hasErrors === errorsFilter

      const visible = matchesOnline && matchesType && matchesErrors
      row.classList.toggle('hidden', !visible)

      if (visible) {
        visibleSections.add(row.dataset.locationType)
      }
    })

    this.sectionHeaderTargets.forEach((header) => {
      header.classList.toggle('hidden', !visibleSections.has(header.dataset.sectionType))
    })
  }

  openErrors (event) {
    const errors = JSON.parse(event.currentTarget.dataset.errors)
    const list = errors.map((e) => `<li class="py-1">${this.escapeHtml(e.error)}</li>`).join('')
    this.modalContentTarget.innerHTML = `<ul class="list-disc pl-5 text-sm">${list}</ul>`
    this.modalTarget.classList.remove('hidden')
  }

  closeModal () {
    this.modalTarget.classList.add('hidden')
    this.modalContentTarget.innerHTML = ''
  }

  escapeHtml (text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
